import { ActionType,responseSensorDetail } from "../../types";

export const SensorDetailsActions = {
sensorDetailsActionStarted: () =>
      ({
          type: 'SensorDetailActions/Load/Started',
      } as const),

      sensorDetailsActionSucceeded: ( status: number, data: responseSensorDetail) =>
      ({
          type: 'SensorDetailActions/Load/Succeeded',
          payload: { status, data },
      } as const),

      sensorDetailsActionFailed: (errorCode: string) =>
      ({
          type: 'SensorDetailActions/Load/Failed',
          payload: { errorCode },
      } as const),
      sensorDetailsActionUnmounted: () =>
      ({
          type: 'SensorDetailActions/Load/Unmounted',
      } as const),
};

export type SensorDetailsActions = ActionType<typeof SensorDetailsActions>;